import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import theme from '../theme';

interface ListingImageProps {
  imageSrc?: string;
  size?: number;
  height?: number;
  width?: number;
  fixProportion?: boolean;
}

const ListingImage: React.FC<ListingImageProps> = ({
  imageSrc,
  size = 44,
  height: _height,
  width: _width,
  fixProportion = false,
}) => {
  const height = _height || size;
  const width = _width || size;

  return (
    <ImageContainer height={height} width={width}>
      {imageSrc ? (
        <ImageFrame imageSrc={imageSrc} />
      ) : (
        <ImageFallbackIconContainer>
          <Icon
            type="antdHomeFilled"
            width={
              fixProportion
                ? `calc(${theme.iconSize} * ${size / 44})`
                : undefined
            }
          />
        </ImageFallbackIconContainer>
      )}
    </ImageContainer>
  );
};

export default ListingImage;

const ImageContainer = styled.div<{ height: number; width: number }>`
  display: flex;
  align-items: center;
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

const ImageLayout = styled.div`
  border-radius: 4px;
  width: 100%;
  height: 100%;
`;

const ImageFrame = styled(ImageLayout)<{ imageSrc: string }>`
  overflow: hidden;
  background-image: url(${props => props.imageSrc});
  background-size: cover;
  background-position: center;
`;

const ImageFallbackIconContainer = styled(ImageLayout)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.gray3};
`;
